import { ComponentChildren } from 'preact';
import { RootUserMenu } from '@components/root-page-layout';
import { MenuItem } from '@components/dropdown';
import { useCurrentUser } from 'client/lib/auth';

/**
 * Common layout wrapper for public calendar pages
 * Provides consistent header with user account menu
 */
export function CalPublicLayout({ children }: { children: ComponentChildren }) {
  const user = useCurrentUser();

  return (
    <div class="p-2 flex flex-col bg-gray-100 min-h-screen">
      <header class="flex justify-end p-4 mb-2">
        {user && (
          <RootUserMenu
            renderMenu={() => (
              <>
                {user.level !== 'student' && (
                  <MenuItem href="/calendar/bookings">My Bookings</MenuItem>
                )}
                <MenuItem href="/calendar/settings">Settings</MenuItem>
                <MenuItem href={`/logout?goto=${encodeURIComponent('/calendar/login')}`}>
                  Logout
                </MenuItem>
              </>
            )}
          />
        )}
      </header>

      <div class="flex items-center justify-center flex-grow">{children}</div>
    </div>
  );
}
